import authState from './auth'

const modules = {
  auth: authState
}

export default modules
